/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PersonalInfoDto } from './personal-info-dto';
import {
    PersonalInfoDtoFromJSON,
    PersonalInfoDtoFromJSONTyped,
    PersonalInfoDtoToJSON,
    PersonalInfoDtoToJSONTyped,
} from './personal-info-dto';
import type { GuestPersonalInfoDto } from './guest-personal-info-dto';
import {
    GuestPersonalInfoDtoFromJSON,
    GuestPersonalInfoDtoFromJSONTyped,
    GuestPersonalInfoDtoToJSON,
    GuestPersonalInfoDtoToJSONTyped,
} from './guest-personal-info-dto';

/**
 * 
 * @export
 * @interface ConfirmBookingRequestDto
 */
export interface ConfirmBookingRequestDto {
    /**
     * 
     * @type {PersonalInfoDto}
     * @memberof ConfirmBookingRequestDto
     */
    userPersonalDetails: PersonalInfoDto;
    /**
     * 
     * @type {GuestPersonalInfoDto}
     * @memberof ConfirmBookingRequestDto
     */
    guestPersonalDetails: GuestPersonalInfoDto | null;
}

/**
 * Check if a given object implements the ConfirmBookingRequestDto interface.
 */
export function instanceOfConfirmBookingRequestDto(value: object): value is ConfirmBookingRequestDto {
    if (!('userPersonalDetails' in value) || value['userPersonalDetails'] === undefined) return false;
    if (!('guestPersonalDetails' in value) || value['guestPersonalDetails'] === undefined) return false;
    return true;
}

export function ConfirmBookingRequestDtoFromJSON(json: any): ConfirmBookingRequestDto {
    return ConfirmBookingRequestDtoFromJSONTyped(json, false);
}

export function ConfirmBookingRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfirmBookingRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'userPersonalDetails': PersonalInfoDtoFromJSON(json['userPersonalDetails']),
        'guestPersonalDetails': GuestPersonalInfoDtoFromJSON(json['guestPersonalDetails']),
    };
}

  export function ConfirmBookingRequestDtoToJSON(json: any): ConfirmBookingRequestDto {
      return ConfirmBookingRequestDtoToJSONTyped(json, false);
  }

  export function ConfirmBookingRequestDtoToJSONTyped(value?: ConfirmBookingRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userPersonalDetails': PersonalInfoDtoToJSON(value['userPersonalDetails']),
        'guestPersonalDetails': GuestPersonalInfoDtoToJSON(value['guestPersonalDetails']),
    };
}

